/**
 * beacon-api.js — thin fetch wrappers for the Support::WidgetController API
 * (see plan section "Backend — Új / módosítandó fájlok" → Support widget API).
 *
 * Contract:
 *   POST /support/widget/conversations             { subject?, body }
 *   GET  /support/widget/conversations              -> [{ id, type, title, snippet, updated_at, count, agent_id? }]
 *   GET  /support/widget/conversations/:id           -> { id, subject, messages: [...] } (email thread only)
 *   GET  /support/widget/ai_conversations/:agent_id  -> { agent_id, messages: [{ id, role, content, created_at }] }
 */

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ''
}

async function requestJson(url, options = {}) {
  const response = await fetch(url, {
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken(),
      ...(options.headers || {}),
    },
    ...options,
  })
  if (!response.ok) {
    const error = new Error(`Request failed: ${response.status}`)
    error.status = response.status
    throw error
  }
  if (response.status === 204) return null
  return response.json()
}

export function createSupportEmail({ subject, body } = {}) {
  return requestJson('/support/widget/conversations', {
    method: 'POST',
    body: JSON.stringify({ subject, body }),
  })
}

export function listWidgetConversations() {
  return requestJson('/support/widget/conversations', { method: 'GET' })
}

export function getWidgetEmailThread(id) {
  return requestJson(`/support/widget/conversations/${encodeURIComponent(id)}`, { method: 'GET' })
}

export function getWidgetAiConversationMessages(agentId) {
  return requestJson(`/support/widget/ai_conversations/${encodeURIComponent(agentId)}`, { method: 'GET' })
}
